<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.atendimentoTipos"
                            @change="handleAtendimentoTipoChange"
                            default-option-text="Todos"
                            label="Tipo de atendimento"
                            show-default-option
                            v-model="model.atendimentoTipo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.ocupacoes"
                            @change="handleOcupacaoChange"
                            default-option-text="Todos"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="form.usuarios"
                            label="Profissional"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <div v-if="items.length > 0">
            <rkm-row>
                <rkm-col style="height: 800px;">
                    <rkm-map
                        :zoom="zoom"
                        ref="RkmMap"
                    >
                        <rkm-map-tile-layer />

                        <rkm-map-marker
                            v-for="(item, index) in items"
                            :key="index"
                            :lat-lng="[item.latitude, item.longitude]"
                        >
                            <rkm-map-tooltip>
                                <p class="m-0"><strong>Tipo de atendimento:</strong> {{item.atendimentoTipo}}</p>
                                <p class="m-0"><strong>Paciente:</strong> {{item.pacienteNome}}</p>
                                <p class="m-0"><strong>Endereço do paciente:</strong> {{item.pacienteEndereco}}</p>
                                <p class="m-0"><strong>Data de atendimento:</strong> {{item.dataAtendimento}}</p>
                                <p class="m-0"><strong>CBO:</strong> {{item.ocupacaoNome}}</p>
                                <p class="m-0"><strong>Profissional:</strong> {{item.usuarioNome}}</p>
                            </rkm-map-tooltip>
                        </rkm-map-marker>
                    </rkm-map>
                </rkm-col>
            </rkm-row>
        </div>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

import L from 'leaflet'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                tipoAtendimento: {required: true},
                ocupacao: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            mapaAtendimento: this.getConectaSusRepository('atencaoBasica.mapaAtendimento'),
        }

        this.load()
    },
    data: () => ({
        form: null,
        items: [],
        model: null,
        others: {moment},
        zoom: 16,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.mapaAtendimento.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAtendimentoTipoChange(value) {
            this.form.ocupacoes = []
            this.form.usuarios = []
            this.model.ocupacaoId = null
            this.model.usuarioId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'ocupacoes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                atendimentoTipo: value,
            }

            this.setLoading()

            this.repositories.mapaAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoChange(value) {
            this.form.usuarios = []
            this.model.usuarioId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'ocupacoes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                atendimentoTipo: this.model.atendimentoTipo,
                ocupacaoId: value,
            }

            this.setLoading()

            this.repositories.mapaAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.usuarios = Object.assign(response.data.usuarios))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                atendimentoTipo: this.model.atendimentoTipo,
                ocupacaoId: this.model.ocupacaoId,
                usuarioId: this.model.usuarioId,
            }

            this.setLoading()

            this.repositories.mapaAtendimento.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data)

                    this.$nextTick(() => {
                        const mapa = this.$refs.RkmMap.getMapObject()

                        const bounds = L.latLngBounds(
                            this.items.map(p => [p.latitude, p.longitude])
                        )

                        mapa.fitBounds(bounds, {maxZoom: 15})
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.atendimentoTipos = []
            this.form.ocupacoes = []
            this.form.usuarios = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.atendimentoTipo = null
            this.model.ocupacaoId = null
            this.model.usuarioId = null

            this.items = []

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.atendimentoTipos = []
                this.form.ocupacoes = []
                this.form.usuarios = []
                this.model.atendimentoTipo = null
                this.model.ocupacaoId = null
                this.model.usuarioId = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'atendimento-tipos',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.mapaAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.atendimentoTipos = Object.assign(response.data.atendimentoTipos)
                        this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
};
</script>
